<script lang="ts">
  export let activeTab: string;
  export let onTabChange: (tab: string) => void = () => {};

  const handleTabClick = (tab: string) => {
    onTabChange(tab);
  };
</script>

<div
  class="mb-5 flex min-w-0 gap-2 overflow-x-auto rounded-t-lg border-b-2 border-white/10 bg-[#24283a]/80 px-4 scrollbar-hide max-[768px]:gap-0"
>
  <button
    class="px-6 py-3 bg-transparent border-solid text-white/60 font-semibold text-sm cursor-pointer border-b-[3px] border-transparent -mb-[2px] transition-all relative hover:text-white hover:bg-white/5 max-[768px]:px-4 max-[768px]:py-3 max-[768px]:whitespace-nowrap"
    class:border-white={activeTab === "overview"}
    class:text-white={activeTab === "overview"}
    on:click={() => handleTabClick("overview")}
  >
    Overview
  </button>
  <button
    class="px-6 py-3 bg-transparent border-solid text-white/60 font-semibold text-sm cursor-pointer border-b-[3px] border-transparent -mb-[2px] transition-all relative hover:text-white hover:bg-white/5 max-[768px]:px-4 max-[768px]:py-3 max-[768px]:whitespace-nowrap"
    class:border-white={activeTab === "invitations"}
    class:text-white={activeTab === "invitations"}
    on:click={() => handleTabClick("invitations")}
  >
    Invitations
  </button>
  <button
    class="px-6 py-3 bg-transparent border-solid text-white/60 font-semibold text-sm cursor-pointer border-b-[3px] border-transparent -mb-[2px] transition-all relative hover:text-white hover:bg-white/5 max-[768px]:px-4 max-[768px]:py-3 max-[768px]:whitespace-nowrap"
    class:border-white={activeTab === "opportunities"}
    class:text-white={activeTab === "opportunities"}
    on:click={() => handleTabClick("opportunities")}
  >
    Opportunities
  </button>
  <button
    class="px-6 py-3 bg-transparent border-solid text-white/60 font-semibold text-sm cursor-pointer border-b-[3px] border-transparent -mb-[2px] transition-all relative hover:text-white hover:bg-white/5 max-[768px]:px-4 max-[768px]:py-3 max-[768px]:whitespace-nowrap"
    class:border-white={activeTab === "conflicts"}
    class:text-white={activeTab === "conflicts"}
    on:click={() => handleTabClick("conflicts")}
  >
    Conflicts
  </button>
  <button
    class="px-6 py-3 bg-transparent border-solid text-white/60 font-semibold text-sm cursor-pointer border-b-[3px] border-transparent -mb-[2px] transition-all relative hover:text-white hover:bg-white/5 max-[768px]:px-4 max-[768px]:py-3 max-[768px]:whitespace-nowrap"
    class:border-white={activeTab === "activity"}
    class:text-white={activeTab === "activity"}
    on:click={() => handleTabClick("activity")}
  >
    Activity Logs
  </button>
</div>
